import React, { useEffect } from "react";
import { initCherryFloating } from "@/lib/cherry";

/** Sitewide Cherry "floating estimator" — the real withCherry widget. */
export function CherryWidget() {
  useEffect(() => {
    initCherryFloating();
  }, []);
  return <div id="floatingEstimator" data-testid="cherry-floating-estimator" />;
}
